import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "summary-card-container" }
const _hoisted_2 = { class: "summary-card-content" }
const _hoisted_3 = { class: "summary-card-progress-bar summary-card-content__progress-bar" }
const _hoisted_4 = { class: "summary-card-content__item-count-label-container" }
const _hoisted_5 = { class: "summary-card-content__item-count-container--label" }
const _hoisted_6 = {
  key: 0,
  class: "summary-card-info__display-detail-label-container"
}
const _hoisted_7 = { class: "summary-card-info__display-detail--label" }
const _hoisted_8 = { key: 1 }

import RoundProgressBar from '@/corePagesModule/components/RoundProgressBar.vue';
import { computed } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryCard',
  props: {
    numerator: {},
    denominator: {},
    detailInfo: { default: '' },
    displayDetailItemType: { default: 'label' }
  },
  setup(__props: any) {

const props = __props;

// プログレスバーコンポーネントに渡す進捗率情報
const displayValue = computed(() => {
  return setProgressValue(props.numerator, props.denominator);
});

/**
 * 進捗率計算を行う
 * @param numerator - 達成件数(分子)
 * @param denominator - 総件数(分母)
 */
const setProgressValue = (numerator: number, denominator: number): number => {
  const value = Math.floor((numerator / denominator) * 100);
  if (Number.isNaN(value)) return 0;
  return value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(RoundProgressBar, { progress: displayValue.value }, null, 8, ["progress"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(`${props.numerator}/${props.denominator}`), 1)
      ]),
      (props.displayDetailItemType === 'label')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(props.detailInfo), 1)
          ]))
        : _createCommentVNode("", true),
      (props.displayDetailItemType === 'tag')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})